module.exports = __webpack_public_path__ + "img/student_lock_screen.0555825a.png";